// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import deleteWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import setQuantityAdjustmentModalIsOpen from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetQuantityAdjustmentModalIsOpen";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import updateWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import translate from "@insite/client-framework/Translate";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
// import MyListsDetailsProductListLine from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine"; // Starter Custom Code
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Move from "@insite/mobius/Icons/Move";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MyListDetailsCategoryView from "@store/Library/Components/Bunzl/MyListDetails/MyListDetailsCategoryView";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { SortableContainer, SortableElement, SortableHandle, SortEvent } from "react-sortable-hoc";
import styled, { css } from "styled-components";

const enum fields {
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    // Store Custom Code
    showSpecificationModal = "showSpecificationModal",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        // Store Custom Code
        [fields.showSpecificationModal]: boolean;
    };
}

/* Starter Custom Code - Start */
import setAllWishListLinesIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetAllWishListLinesIsSelected";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import getColor from "@insite/mobius/utilities/getColor";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import StoreCheckoutCartLinesHeaderInformations, {
    StoreCheckoutCartLinesHeaderInformationsStyles,
    StoreCheckoutCartLinesHeaderProps,
} from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutCartLinesHeaderInformations";

import { formGridProps } from "@store/Themes/common/props/form";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
// Store Custom Code
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import setEditingSortOrder from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetEditingSortOrder";

import MyListsDetailsProductListLine from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
// import MyListsDetailsProductListLine from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine"; bunzl custom code
import ViewReplacementProductModal from "@insite/content-library/Widgets/MyListsDetails/ViewReplacementProductModal";
import MyListsDetailsBunzlProductListLine from "@store/Library/Widgets/MyListDetails/MyListsDetailsBunzlProductListLine";
import useShowMyListDetailsCategoryView from "@store/Overrides/Widgets/MyListsDetails/useShowMyListDetailsCategoryView";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// Store Custom Code
import { MyListDetailsCategoryToggle } from "@store/Library/Widgets/MyListDetails/MyListDetailsCategoryToggle";
import { historyTableProps } from "@store/Themes/common/props/history";

const Pagination = getWidgetComponent("MyListsDetails/MyListDetailsPagination");
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    wishListDataView: getWishListState(state, state.pages.myListDetails.wishListId),
    // Store Custom Code - >
    categoryDataView:
        state.bunzl.pages.myListDetailsCategory.dataViews[
            getDataViewKey(state.pages.myListDetails.loadWishListLinesParameter)
        ],
    categoryDataById: state.bunzl.pages.myListDetailsCategory.byId,
    // <---- bunzl custom code
    wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
    productInfosByWishListLineId: state.pages.myListDetails.productInfosByWishListLineId,
    loadWishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
    editingSortOrder: state.pages.myListDetails.editingSortOrder,
    quantityAdjustmentModalIsOpen: state.pages.myListDetails.quantityAdjustmentModalIsOpen,
    selectedWishListLineIds: state.pages.myListDetails.selectedWishListLineIds, // Starter Custom Code
});

const mapDispatchToProps = {
    updateLoadWishListLinesParameter,
    loadWishListLines,
    updateWishListLine,
    setEditingSortOrder, // Store Custom Code
    deleteWishListLine,
    setQuantityAdjustmentModalIsOpen,
    setAllWishListLinesIsSelected, // Starter Custom Code
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface MyListsDetailsProductListStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    messageText?: TypographyPresentationProps;
    container?: GridContainerProps;
    lineGridItem?: GridItemProps;
    sortOrderWrapper?: InjectableCss;
    dragHandleIcon?: IconPresentationProps;
    sortOrderTextField?: TextFieldProps;
    editNotesModal?: ModalPresentationProps;
    paginationContainer?: GridContainerProps;
    paginationGridItem?: GridItemProps;
    pagination?: PaginationPresentationProps;
    notesTextArea?: TextAreaProps;
    editNotesModalButtonsWrapper?: InjectableCss;
    editNotesModalDeleteButton?: ButtonPresentationProps;
    editNotesModalCancelButton?: ButtonPresentationProps;
    editNotesModalSubmitButton?: ButtonPresentationProps;
    quantityAdjustmentModal?: ModalPresentationProps;
    quantityAdjustedText?: TypographyPresentationProps;
    // Starter Custom Code
    loadingOverlay?: LoadingOverlayProps;
    wrapper?: InjectableCss;
    linesCountWrapper?: InjectableCss;
    linesCount?: TypographyPresentationProps;
    selectAll?: CheckboxPresentationProps;
    linesWrapper?: InjectableCss;
    notesContainer?: GridContainerProps;
    notesGridItem?: GridItemProps;
    storeCheckoutHeaderStyles?: StoreCheckoutCartLinesHeaderInformationsStyles;
}

export const productListStyles: MyListsDetailsProductListStyles = {
    centeringWrapper: {
        css: css`
            height: ${pxToRem(300)};
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },

    linesWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    loadingOverlay: historyTableProps.loadingOverlay,
    linesCountWrapper: resultCountProps.wrapper,
    linesCount: mergeProps<MyListsDetailsProductListStyles["linesCount"]>(resultCountProps.countText, {
        css: css`
            margin: 0;
        `,
    }),
    messageText: typographyGetNoResultsAltProps({ spaced: true }),
    selectAll: resultCountProps.selectAll,
    container: {
        ...productLineProps.container,
        css: css`
            ${productLineProps.container?.css}
            gap: 0;
        `,
    },
    lineGridItem: {
        width: 12,
        css: css`
            position: relative;
            border-bottom: ${pxToRem(1)} ${getColor("common.border")} solid;
            /* Bunzl Custom Code */
            padding-block: ${({ theme }) => theme.design.layout.spacing.small};
        `,
    },
    notesContainer: formGridProps.gridContainer,
    notesGridItem: { width: 12 },
    editNotesModal: { sizeVariant: "medium" },
    editNotesModalDeleteButton: { variant: "primary" },
    editNotesModalCancelButton: { variant: "secondary" },
    quantityAdjustmentModal: { sizeVariant: "medium" },
    storeCheckoutHeaderStyles: {
        productInfosGridItem: {
            width: 5,
        },
        productControlsGridItem: {
            width: 7,
        },
        productControlsItem: {
            css: css`
                width: 100%;
            `,
        },
    },
};

const styles = productListStyles;

const MyListsDetailsProductList: React.FC<Props> = ({
    wishListDataView,
    wishListLinesDataView: baseWishListLinesDataView, // Starter Custom Code
    productInfosByWishListLineId,
    loadWishListLinesParameter,
    editingSortOrder,
    quantityAdjustmentModalIsOpen,
    updateWishListLine,
    deleteWishListLine,
    setQuantityAdjustmentModalIsOpen,
    fields,
    selectedWishListLineIds, // Starter Custom Code
    setEditingSortOrder, // bunzl custom
    setAllWishListLinesIsSelected, // Starter Custom Code
}) => {
    /* Starter Custom Code - Start */
    const productInfos = getMatchingDataFromDictionary(baseWishListLinesDataView.value, productInfosByWishListLineId);
    const trackRemoveFromWishList = ga.use.trackRemoveFromWishList();
    /* Starter Custom Code - End */
    // Store Custom Code - >

    // this is needed to fix a visual bug caused by react-hoc-sortable.  Currently without this fix the dragging element is not visible.
    // the sortable container takes a helperClass (in this case sortable-helper) and adds it to the dragging element.  Numerous attempts to add the class styling with styled components failed
    // so this is a workaround to add the class to the head of the document on mount and remove it on unmount.
    useEffect(() => {
        const head = document.head;
        const style = document.createElement("style");

        style.innerHTML = ".sortable-helper { z-index: 9999; outline: 2px solid #0D2C6B; outline-offset: .25rem;}";

        head.appendChild(style);
        return () => {
            head.removeChild(style);
        };
    }, []);

    const showMyListDetailCategoryView = useShowMyListDetailsCategoryView();
    // <---- bunzl custom code
    const [wishListLineToAction, setWishListLineToAction] = React.useState<WishListLineModel | null>(null);
    const [wishListLineToReplacement, setWishListLineToReplacement] = React.useState<WishListLineModel | null>(null);

    const [deleteLineModalIsOpen, setDeleteLineModalIsOpen] = React.useState(false);
    const [editNotesModalIsOpen, setEditNotesModalIsOpen] = React.useState(false);
    const [viewReplacementProductModalIsOpen, setViewReplacementModelIsOpen] = React.useState(false);
    const { showImageBadges, showTextBadges, maximumNumberOfImageBadges, maximumNumberOfTextBadges } = fields;

    /* Starter Custom Code - Start */
    const wishListLinesDataView = usePersistentDataView(baseWishListLinesDataView);

    if (!wishListDataView.value) {
        return null;
    }
    /* Starter Custom Code - End */

    // Store Custom Code
    const { showSpecificationModal } = fields;
    const wishList = wishListDataView.value;
    const wishListLines = wishListLinesDataView.value;
    /* Store Custom Code - Start */
    let linesCount = 0;
    if ("pagination" in wishListLinesDataView) {
        linesCount = wishListLinesDataView?.pagination?.totalItemCount ?? 0;
    }
    /* Store Custom Code - End */
    const deleteCancelHandler = () => {
        setDeleteLineModalIsOpen(false);
    };

    const deleteSubmitHandler = () => {
        if (!wishListLineToAction) {
            return;
        }
        deleteWishListLine({
            wishListId: wishList.id,
            wishListLineId: wishListLineToAction.id,
            onSuccess: () => {
                setDeleteLineModalIsOpen(false);
                /* Starter Custom Code - Start */
                const product = wishList.wishListLineCollection?.find(x => x.id === wishListLineToAction.id);
                const productInfo = productInfos.filter(x => x.productId === wishListLineToAction.productId);
                trackRemoveFromWishList({ items: product }, { productInfos: productInfo, wishList });
                /* Starter Custom Code - End */
            },
            onComplete() {
                // "this" is targeting the object being created, not the parent SFC
                // eslint-disable-next-line react/no-this-in-sfc
                this.onSuccess?.();
            },
        });
    };

    const deleteClickHandler = (wishListLine: WishListLineModel) => {
        setWishListLineToAction(wishListLine);
        setDeleteLineModalIsOpen(true);
    };

    const editNotesModalCancelHandler = () => {
        setEditNotesModalIsOpen(false);
    };

    const editNotesClickHandler = (wishListLine: WishListLineModel) => {
        setWishListLineToAction(wishListLine);
        setEditNotesModalIsOpen(true);
    };

    const viewReplacementProductClickHandler = (wishListLine: WishListLineModel) => {
        setWishListLineToReplacement(wishListLine);
        setViewReplacementModelIsOpen(true);
    };

    const viewReplacementProductCancelHandler = () => {
        setViewReplacementModelIsOpen(false);
    };

    const editNotesModalSubmitHandler = (notes: string) => {
        const wishListLineToUpdate = { ...wishListLineToAction, notes } as WishListLineModel;
        updateWishListLine({
            wishListId: wishList.id,
            wishListLineId: wishListLineToUpdate.id,
            wishListLine: wishListLineToUpdate,
            skipResettingData: true,
            onSuccess: () => {
                setEditNotesModalIsOpen(false);
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishListLine) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.();
                }
            },
        });
    };

    const updateSortOrder = (wishListLine: WishListLineModel, value: number | string) => {
        const sortOrder = parseInt(value.toString() || "1", 10);
        if (wishListLine.sortOrder === sortOrder) {
            return;
        }

        const wishListLineToUpdate = { ...wishListLine, sortOrder };
        updateWishListLine({
            wishListId: wishList.id,
            wishListLineId: wishListLineToUpdate.id,
            wishListLine: wishListLineToUpdate,
        });
    };

    const sortMove = (e: SortEvent) => {
        e.preventDefault();

        let clientY = 0;
        if ((e as any).clientY !== undefined) {
            clientY = (e as any).clientY;
        } else if ((e as any).targetTouches !== undefined) {
            clientY = (e as any).targetTouches[0].clientY;
        } else {
            return;
        }

        if (clientY < 50) {
            scroll(-20);
        } else if (clientY < 100) {
            scroll(-10);
        }

        const bottom = window.innerHeight - clientY;
        if (bottom < 50) {
            scroll(20);
        } else if (bottom < 100) {
            scroll(10);
        }
    };

    const scroll = (step: number) => {
        window.scrollBy(0, step);
    };

    const quantityAdjustmentModalCancelHandler = () => {
        setQuantityAdjustmentModalIsOpen({ modalIsOpen: false });
    };

    // Starter Moved - messageText - down

    /* Starter Custom Code - Start */
    const isAllSelected =
        wishListLines &&
        wishListLines.length > 0 &&
        wishListLines?.every(o => selectedWishListLineIds.indexOf(o.id) >= 0);

    const selectAllChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        const allWishListLineIds = value ? wishListLines?.map(o => o.id) : undefined;
        setAllWishListLinesIsSelected({ isSelected: value, wishListLineIds: allWishListLineIds });
    };

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };
    const headerProps: StoreCheckoutCartLinesHeaderProps = {
        controlLabels: [
            { label: translate("Quantity") },
            { label: translate("Extended Price") },
            { label: translate("Availability") },
            // Store Custom Code
            { label: "" },
        ],
        extendedStyles: styles.storeCheckoutHeaderStyles,
    };

    /* Starter Custom Code - End */

    return (
        <DataViewLoadingOverlay
            dataView={wishListLinesDataView}
            {...styles.loadingOverlay}
            /* Starter Custom Code */
            id="myListDetailsProductList" /* Store Custom Code */
        >
            {!wishListLines?.length /* Starter Custom Code */ ? (
                <Typography {...styles.messageText} data-test-selector="myListDetails_noItemsMessage">
                    {loadWishListLinesParameter.query
                        ? siteMessage("Lists_NoResultsMessage")
                        : siteMessage("Lists_NoItemsInList")}
                </Typography>
            ) : (
                <StyledWrapper {...styles.wrapper} /* Starter Custom Code */>
                    {/* Starter Custom Code - Start */}
                    <StyledWrapper {...styles.linesCountWrapper}>
                        <Checkbox
                            {...styles.selectAll}
                            checked={isAllSelected}
                            onChange={selectAllChangeHandler}
                            data-test-selector="selectAllItems"
                        >
                            {translate("Select All")}
                        </Checkbox>
                        {/* Store Custom Code - Start */}
                        {!showMyListDetailCategoryView && (wishList.allowEdit || !wishList.isSharedList) && (
                            <Checkbox
                                {...styles.selectAll}
                                checked={editingSortOrder}
                                onChange={() => setEditingSortOrder({ editingSortOrder: !editingSortOrder })}
                                data-test-selector="editingSortOrderCheckBox"
                            >
                                {translate("Edit Sort Order")}
                            </Checkbox>
                        )}
                        {/* Store Custom Code - End */}
                        <Typography {...styles.linesCount}>
                            {linesCount} {linesCount === 1 ? translate("Item") : translate("Items")}
                        </Typography>
                        <MyListDetailsCategoryToggle />
                    </StyledWrapper>
                    {/* Starter Custom Code - End */}
                    {/* Store Custom Code */}
                    <StoreCheckoutCartLinesHeaderInformations {...headerProps} />
                    {!showMyListDetailCategoryView && (
                        <LinesContainer
                            // Store Custom Code - Fixed the issue with the dragging element not being visible
                            helperClass="sortable-helper"
                            wishList={wishList}
                            wishListLines={wishListLines}
                            productInfosByWishListLineId={productInfosByWishListLineId}
                            editingSortOrder={editingSortOrder && !loadWishListLinesParameter.query}
                            canDrag={(wishListLinesDataView as any).pagination.numberOfPages === 1} // Starter Custom Code
                            updateSortOrder={updateSortOrder}
                            onDeleteClick={deleteClickHandler}
                            onEditNotesClick={editNotesClickHandler}
                            useDragHandle={true}
                            lockAxis="y"
                            lockToContainerEdges={true}
                            onViewProductReplacement={viewReplacementProductClickHandler}
                            lockOffset="0%"
                            onSortStart={(_, e) => e.preventDefault()}
                            onSortMove={sortMove}
                            onSortEnd={({ oldIndex, newIndex }) =>
                                updateSortOrder(wishListLines[oldIndex], newIndex + 1)
                            }
                            showImageBadges={showImageBadges}
                            showTextBadges={showTextBadges}
                            maximumNumberOfImageBadges={maximumNumberOfImageBadges}
                            maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                            // Store Custom Code
                            showSpecificationModal={showSpecificationModal}
                        />
                    )}
                    {/* Store Custom Code - Start */}
                    {showMyListDetailCategoryView && (
                        <MyListDetailsCategoryView
                            wrapperStyles={styles.linesWrapper}
                            maximumNumberOfImageBadges={maximumNumberOfImageBadges}
                            maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                            showImageBadges={showImageBadges}
                            showTextBadges={showTextBadges}
                            onDeleteClick={deleteClickHandler}
                            onEditNotesClick={editNotesClickHandler}
                            productInfosByWishListLineId={productInfosByWishListLineId}
                            wishList={wishList}
                            gridContainerStyles={styles.lineGridItem}
                        />
                    )}
                    {/* Store Custom Code - End */}
                    <TwoButtonModal
                        modalIsOpen={deleteLineModalIsOpen}
                        headlineText={translate("Delete List Item")}
                        messageText={`${translate("Are you sure you want to delete this item?")}`}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Delete")}
                        onCancel={deleteCancelHandler}
                        onSubmit={deleteSubmitHandler}
                        submitTestSelector="submitDeleteListItem"
                    />
                    {wishListLineToAction && (
                        <Modal
                            {...styles.editNotesModal}
                            headline={translate(`${wishListLineToAction.notes ? "Edit" : "Add"} Notes`)}
                            isOpen={editNotesModalIsOpen}
                            handleClose={editNotesModalCancelHandler}
                        >
                            <EditNotesForm
                                wishListLine={wishListLineToAction}
                                onCancel={editNotesModalCancelHandler}
                                onSubmit={editNotesModalSubmitHandler}
                            />
                        </Modal>
                    )}
                    <Modal
                        {...styles.quantityAdjustmentModal}
                        headline={translate("Quantity Adjustment Has Been Made")}
                        isOpen={quantityAdjustmentModalIsOpen}
                        handleClose={quantityAdjustmentModalCancelHandler}
                    >
                        <Typography {...styles.quantityAdjustedText}>
                            {siteMessage("Lists_QuantitiesAdjusted")}
                        </Typography>
                    </Modal>
                    {wishListLineToReplacement && (
                        <ViewReplacementProductModal
                            isOpen={viewReplacementProductModalIsOpen}
                            handleClose={viewReplacementProductCancelHandler}
                            wishList={wishList}
                            wishListLine={wishListLineToReplacement}
                            wishListLines={wishListLines}
                        />
                    )}
                    <Pagination /* Starter Custom Code */ />
                </StyledWrapper>
            )}
        </DataViewLoadingOverlay>
    );
};

/* Starter Removed - SortableHandle */

interface LineItemProps {
    wishList: WishListModel;
    wishListLine: WishListLineModel;
    productInfo: ProductInfo;
    editingSortOrder: boolean;
    canDrag: boolean;
    updateSortOrder: (wishListLine: WishListLineModel, value: number | string) => void;
    onDeleteClick: (wishListLine: WishListLineModel) => void;
    onEditNotesClick: (wishListLine: WishListLineModel) => void;
    showImageBadges: boolean;
    showTextBadges: boolean;
    maximumNumberOfImageBadges: number;
    maximumNumberOfTextBadges: number;
    onViewReplacementProduct: (wishListLine: WishListLineModel) => void;
    // Store Custom Code
    showSpecificationModal: boolean;
}

const LineItem = SortableElement<LineItemProps>(
    ({
        wishList,
        wishListLine,
        productInfo,
        editingSortOrder,
        canDrag,
        updateSortOrder,
        onDeleteClick,
        onEditNotesClick,
        showImageBadges,
        showTextBadges,
        maximumNumberOfImageBadges,
        maximumNumberOfTextBadges,
        onViewReplacementProduct,
        // Store Custom Code
        showSpecificationModal,
    }: LineItemProps) => {
        // Starter Removed - sortOrderBlurHandler

        // Starter Removed - sortOrderKeyPressHandler
        // bunzl changed to use the refactored component
        return (
            <GridItem {...styles.lineGridItem} /* Starter Custom Code */>
                <MyListsDetailsBunzlProductListLine
                    canDrag={canDrag} // Starter Custom Code
                    wishList={wishList}
                    wishListLine={wishListLine}
                    productInfo={productInfo}
                    onDeleteClick={onDeleteClick}
                    onEditNotesClick={onEditNotesClick}
                    isEditingSortOrder={editingSortOrder}
                    showImageBadges={showImageBadges}
                    showTextBadges={showTextBadges}
                    maximumNumberOfImageBadges={maximumNumberOfImageBadges}
                    maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                    onViewReplacementProduct={onViewReplacementProduct}
                    showSpecificationModal={showSpecificationModal}
                />
            </GridItem>
        );
    },
);

interface LinesContainerProps {
    wishList: WishListModel;
    wishListLines: WishListLineModel[];
    productInfosByWishListLineId: SafeDictionary<ProductInfo>;
    editingSortOrder: boolean;
    canDrag: boolean;
    updateSortOrder: (wishListLine: WishListLineModel, value: number | string) => void;
    onDeleteClick: (wishListLine: WishListLineModel) => void;
    onEditNotesClick: (wishListLine: WishListLineModel) => void;
    showImageBadges: boolean;
    showTextBadges: boolean;
    maximumNumberOfImageBadges: number;
    maximumNumberOfTextBadges: number;
    onViewProductReplacement: (wishListLine: WishListLineModel) => void;
    // Store Custom Code
    showSpecificationModal: boolean;
}

const LinesContainer = SortableContainer<LinesContainerProps>(
    ({
        wishList,
        wishListLines,
        productInfosByWishListLineId,
        editingSortOrder,
        canDrag,
        updateSortOrder,
        onDeleteClick,
        onEditNotesClick,
        showImageBadges,
        showTextBadges,
        maximumNumberOfImageBadges,
        maximumNumberOfTextBadges,
        onViewProductReplacement,
        showSpecificationModal,
    }: LinesContainerProps) => {
        const lines = wishListLines.filter(wishListLine => !!productInfosByWishListLineId[wishListLine.id]); // Starter Custom Code
        const wrapperStyles = styles.linesWrapper;

        return (
            <StyledWrapper {...wrapperStyles} data-test-selector="myListDetails_lines" /* Starter Custom Code */>
                <StyledWrapper {...productLineProps.spacer} /* Starter Custom Code */ />
                {lines.map((wishListLine, index /* Starter Custom Code */) => (
                    <LineItem
                        key={`${wishListLine.productId}_${wishListLine.selectedUnitOfMeasure}`}
                        index={index}
                        wishList={wishList}
                        wishListLine={wishListLine}
                        productInfo={productInfosByWishListLineId[wishListLine.id]!}
                        editingSortOrder={editingSortOrder}
                        canDrag={canDrag}
                        updateSortOrder={updateSortOrder}
                        onDeleteClick={onDeleteClick}
                        onEditNotesClick={onEditNotesClick}
                        showImageBadges={showImageBadges}
                        showTextBadges={showTextBadges}
                        maximumNumberOfImageBadges={maximumNumberOfImageBadges}
                        maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                        // Store Custom Code
                        showSpecificationModal={showSpecificationModal}
                        onViewReplacementProduct={onViewProductReplacement}
                    />
                ))}
            </StyledWrapper>
        );
    },
);

interface EditNotesFormProps {
    wishListLine: WishListLineModel;
    onCancel: () => void;
    onSubmit: (notes: string) => void;
}

const EditNotesForm: React.FC<EditNotesFormProps> = ({ wishListLine, onCancel, onSubmit }) => {
    const [notes, setNotes] = React.useState(wishListLine.notes);
    const notesChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNotes(event.target.value.length > 300 ? event.target.value.slice(0, 300) : event.target.value);
    };

    const deleteHandler = () => {
        setNotes("");
        onSubmit("");
    };

    return (
        <>
            <GridContainer {...styles.notesContainer} /* Starter Custom Code */>
                <GridItem {...styles.notesGridItem} /* Starter Custom Code */>
                    <TextArea
                        {...styles.notesTextArea}
                        value={notes}
                        onChange={notesChangeHandler}
                        hint={`${300 - notes.length} ${translate("characters left")}`}
                        data-test-selector="myLists_editNote"
                    />
                </GridItem>
            </GridContainer>
            {/* Starter Removed - editNotesModalButtonsWrapper */}
            <FormActions /* Starter Custom Code */>
                {wishListLine.notes && (
                    <Button
                        {...styles.editNotesModalDeleteButton}
                        onClick={deleteHandler}
                        data-test-selector="myLists_deleteNoteButton"
                    >
                        {translate("Delete Note")}
                    </Button>
                )}
                {/* Starter Custom Code - Start */}
                <Button
                    {...styles.editNotesModalSubmitButton}
                    onClick={() => onSubmit(notes)}
                    data-test-selector="myLists_submitNoteButton"
                >
                    {translate(`${wishListLine.notes ? "Save" : "Add Notes"}`)}
                </Button>
                {/* Starter Custom Code - End */}
                <Button
                    {...styles.editNotesModalCancelButton}
                    onClick={onCancel}
                    data-test-selector="myLists_cancelNoteButton"
                >
                    {translate("Cancel")}
                </Button>
                {/* Starter Moved - editNotesModalSubmitButton - up */}
            </FormActions>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyListsDetailsProductList),
    definition: {
        group: "My Lists Details",
        displayName: "Product List",
        allowedContexts: ["MyListsDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showSpecificationModal,
                displayName: "Show Specification Modal",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 5,
            },
        ],
    },
};

export default widgetModule;
